import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { host } from '../axiosInterceptor'

const host_app = process.env.REACT_APP_URL_APP;

function Mission() {


  return (
    <Container fluid>
        <Row className='justify-content-center pt-4'>
            <Col md lg xl = "11">
                <Row>
                    <Col>
                        <h3>¿Qué es el CEDIJ?</h3>
                        <p style={{textAlign:"justify"}}>
                            Es un órgano técnico especializado del Poder Judicial de Nicaragua adscrito al Consejo Nacional
                            de Administración y Carrera Judicial por Acuerdo No. 33 del 2003, 305 y 306 del 2015.
                        </p>

                        <h3>Visión</h3>
                        <p style={{textAlign:"justify"}}>
                            Ser un centro especializado de documentación, investigación e información judicial que disponga
                            de un excelente sistemas de organización y gestión, con personal especializado que genere confianza
                            y recursos tecnológicos, contribuyendo a fortalecer la administración de justicia con el desarrollo
                            de los funcionarios judiciales y usuarios en general.
                        </p>

                        <h3>Misión</h3>
                        <p style={{textAlign:"justify"}}>
                            La misión del CEDIJ es gestionar el conocimiento en el ámbito jurídico, jurisprudencial, doctrinal y
                            legislativo, en conformidad con el ordenamiento jurídico, los procesos documentales, la calidad en
                            la prestación de los servicios y las nuevas tecnologías, poniendo a disposición el acervo jurídico 
                            enriquecido a funcionarios judiciales y usuarios en general para facilitar el acceso a la información
                            especializada.
                        </p>
                    </Col>
                    <Col>

                        <h3>Objetivo General</h3>
                        <p style={{textAlign:"justify"}}>
                            Dotar a los magistrados y jueces del país de información judicial y elementos jurídicos encaminados a la 
                            unificación de criterios de los funcionarios judiciales y con ella procurar resoluciones ágiles, imparciales
                            y ajustadas a derecho.
                        </p>

                        <h3>Políticas</h3>
                        <p style={{textAlign:"justify"}}>
                            Mejorar continuamente el proceso de investigación y análisis de las sentencias jurisprudencial, legislación y 
                            doctrina, la que será almacenada, publicada y divulgada por el CEDIJ en formato electrónico y digital.
                        </p>

                        <p style={{textAlign:"justify"}}>
                            Nuestra publicaciones satisfagan las necesidades informativas, científicas e investigativas de los funcionarios
                            de carrera judicial, para el apoyo de las funciones jurisdiccionales.
                        </p>

                        {/* <Row>
                            <Col>
                                <img src={`${host_app}/icopdf.png`} className='d-table ms-auto me-auto' style={{width:"100px"}} alt="" />
                                <a href={`${host}/assets/documents/agreement/AcuerdoNo305.pdf`} target='_blank' className='d-table p-2 link-info link-underline-opacity-0 text-center w-100' rel="noreferrer">Acuerdo No. 305</a>
                            </Col>
                            <Col>
                                <img src={`${host_app}/icopdf.png`} className='d-table ms-auto me-auto' style={{width:"100px"}} alt="" />
                                <a href={`${host}/assets/documents/agreement/AcuerdoNo.033-2003.pdf`} target='_blank' className='d-table p-2 link-info link-underline-opacity-0 text-center w-100' rel="noreferrer">Acuerdo No. 303-2003</a>
                            </Col>
                            <Col>
                            <img src={`${host_app}/icopdf.png`} className='d-table ms-auto me-auto' style={{width:"100px"}} alt="" />
                            <a href={`${host}/assets/documents/agreement/AcuerdoNo306.pdf`} target='_blank' className='d-table p-2 link-info link-underline-opacity-0 text-center w-100' rel="noreferrer">Acuerdo No. 306</a>
                            </Col>
                        </Row> */}
                    </Col>
                </Row>
            </Col>
        </Row>
    </Container>
  )
}

export default Mission